import CompanyCrud from "../components/company/CompanyCrud";

const CompanyPage = () => {
  return <CompanyCrud />;
};

export default CompanyPage;
